import { VenueCarouselItem } from "@punchup/data/models";
import ImageCarouselItem from "./ImageCarouselItem";
import VideoCarouselItem from "./VideoCarouselItem";
import ShowPreviewCard from "./ShowPreviewCard";

interface Props {
  item: VenueCarouselItem;
  previewUrls: Map<string, string>;
  venuePageId: string;
}

export default function CarouselItem({
  item,
  previewUrls,
  venuePageId,
}: Props) {
  switch (item.type) {
    case "image":
      return (
        <ImageCarouselItem
          item={item}
          previewUrl={previewUrls.get(item.image.imageId)}
        />
      );
    case "video":
      return <VideoCarouselItem item={item} />;
    case "show":
      return <ShowPreviewCard show={item.show} venuePageId={venuePageId} />;
  }
}
